import classnames from 'classnames';
import { Dispatch, SetStateAction } from 'react';

import Label from '../Label';
import Text from '../Text';
import { ListType } from 'types/selectbox';

interface RadioSetProps {
  label: string;
  labelTooltip?: string;
  list: ListType[];
  value: number | string;
  setValue?: Dispatch<SetStateAction<number | string>>;
  className?: string;
  onChange?: (value: number | string) => void;
}

interface RadioProps {
  isSelected?: boolean;
  label: string;
  onClick: () => void;
}

const Radio = ({ isSelected, label, onClick }: RadioProps) => {
  return (
    <button type="button" className="flex flex-row items-center gap-2" onClick={onClick}>
      <div
        className={classnames(
          'relative flex h-4 w-4 items-center justify-center rounded-full border',
          {
            'border-radio-active before:absolute before:h-2 before:w-2 before:rounded-full before:bg-radio-active':
              isSelected
          },
          { 'border-radio-inactive': !isSelected }
        )}
      />
      <Text size="body2" weight="regular" color="primary">
        {label}
      </Text>
    </button>
  );
};

const RadioSet = ({ label, labelTooltip, list, value, setValue, onChange, className }: RadioSetProps) => {
  const handleChange = (newValue: number | string) => {
    if (setValue) {
      setValue(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  };
  return (
    <div className={classnames('flex flex-col gap-2', className)}>
      <Label label={label} labelTooltip={labelTooltip} />
      <div className="flex flex-row gap-4">
        {list.map((listItem, index) => (
          <Radio
            label={listItem.label}
            key={`${listItem.label}_${index}`}
            isSelected={listItem.value === value}
            onClick={() => handleChange(listItem.value)}
          />
        ))}
      </div>
    </div>
  );
};

export default RadioSet;
